import { ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

interface HeaderTextBlockProps {
    header: ReactNode;
    subHeader?: ReactNode;
    cta?: ReactNode;
}

const headerTextBlock = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingBlockStart: token("space.600"),
    paddingBlockEnd: token("space.800"),
    [media.below.sm]: {
        alignItems: "center"
    }
});

const headerText = css({
    textAlign: "center",
    margin: 0,
    padding: "0 0 16px 0"
});

const headerSubText = css({
    textAlign: "center",
    margin: 0,
    padding: "0 0 16px 0"
});

const button = css({
    textAlign: "center",
    a: {
        fontWeight: 400,
        color: "#fff"
    }
});

export const HeaderTextBlock = ({
    header,
    subHeader,
    cta
}: HeaderTextBlockProps) => {
    return (
        <div css={headerTextBlock}>
            <h1 css={headerText} className="superhero-contrast">
                {header}
            </h1>
            {subHeader && (
                <p css={headerSubText} className="body-lg">
                    {subHeader}
                </p>
            )}
            {cta && <div css={button}>{cta}</div>}
        </div>
    );
};

export default HeaderTextBlock;
